import { TransactionCreateRequestDto } from './transaction-create.request.dto';

export type TransactionUpdateRequestDto = Partial<TransactionCreateRequestDto>;
